const buildOptions = options => {
  const defaultOptions = _buildDefaultOptions();
  return {
    hint: _getOptionValue(options.hint, defaultOptions.hint),
    autoselect: _getOptionValue(options.autoselect, defaultOptions.autoselect),
    openOnFocus: _getOptionValue(options.openOnFocus, defaultOptions.openOnFocus),
    cssClasses: {
      root: _getOptionValue(options.rootCssClasses, defaultOptions.cssClasses.root),
      noPrefix: _getOptionValue(options.noPrefixCssClasses, defaultOptions.cssClasses.noPrefix),
      dropdownMenu: _getOptionValue(options.dropdownMenuCssClasses, defaultOptions.cssClasses.dropdownMenu),
      suggestion: _getOptionValue(options.suggestionCssClasses, defaultOptions.cssClasses.suggestion)
    },
    debug: _getOptionValue(options.debug, defaultOptions.debug)
  }
};

const buildSuggestionOptions = options => {
  const defaultSuggestionOptions = _buildDefaultSuggestionOptions(options);
  return [{
    display: _getOptionValue(options.display, defaultSuggestionOptions.display),
    source: _getOptionValue(options._getData, defaultSuggestionOptions.source),
    templates: {
      header: _getOptionValue(options.headerTemplate, defaultSuggestionOptions.templates.header),
      suggestion: _getOptionValue(options.getSuggestionTemplate, defaultSuggestionOptions.templates.suggestion),
      header: _getOptionValue(options.headerTemplate, defaultSuggestionOptions.templates.header),
      footer: _getOptionValue(options.footerTemplate, defaultSuggestionOptions.templates.footer),
      empty: _getOptionValue(options.emptyTemplate, defaultSuggestionOptions.templates.empty)
    }
  }];
};

const _buildDefaultOptions = () => ({
  hint: true,
  autoselect: true,
  openOnFocus: true,
  cssClasses: {
    root: 'autocomplete',
    noPrefix: true,
    dropdownMenu: 'autocomplete-dropdown',
    suggestion: 'autocomplete-dropdown-suggestion'
  },
  debug: false
});

const _buildDefaultSuggestionOptions = options => ({
  display: null,
  source: options._getData,
  templates: {
    header: null,
    suggestion: options.getSuggestionTemplate,
    header: options.getHeaderTemplate,
    footer: options.getFooterTemplate,
    empty: options.getEmptySuggestionsTemplate
  }
});

const _getOptionValue = (optionValue, defaultValue) => {
  if (optionValue === null || typeof optionValue === 'undefined') {
    return defaultValue;
  }
  return optionValue;
};

export default {
  buildOptions,
  buildSuggestionOptions
};
